import { redirect } from "react-router-dom";
import { authService } from "../auth/authService";
import { RoleEnum } from "@/types/auth/roleEnum";

export const LecturerProtectedLoader = () => {
  const roles = authService.userData?.roles;
  if (!authService.getAccessToken() || !roles?.includes(RoleEnum.Lecturer)) {
    authService.clearTokens();
    throw redirect("/login");
  }
  return null;
};
